import { api } from '@xtnd/web/shared/api';

export interface ModuleConfigurationStatus {
  module: string;
  isConfigured: boolean;
  requiresAttention: boolean;
  status: 'healthy' | 'warning' | 'error' | 'not_configured';
  errors: string[];
  warnings: string[];
  lastChecked: string;
  healthEndpoint: string;
}

export interface ConfigurationStatusSummary {
  totalModules: number;
  configuredModules: number;
  modulesRequiringAttention: number;
  lastChecked: string;
}

export interface ConfigurationStatusResponse {
  summary: ConfigurationStatusSummary;
  modules: ModuleConfigurationStatus[];
}

class ConfigurationStatusApi {
  /**
   * Get configuration status for all modules
   */
  async getConfigurationStatus(): Promise<ConfigurationStatusResponse> {
    return api.get<ConfigurationStatusResponse>('/tenants/current/configuration-status');
  }

  /**
   * Get configuration status for a specific module
   */
  getModuleStatus(allStatuses: ModuleConfigurationStatus[], moduleName: string): ModuleConfigurationStatus | undefined {
    return allStatuses.find(status => status.module === moduleName);
  }

  /**
   * Check if a module is configured
   */
  isModuleConfigured(allStatuses: ModuleConfigurationStatus[], moduleName: string): boolean {
    const moduleStatus = this.getModuleStatus(allStatuses, moduleName);
    return moduleStatus?.isConfigured ?? false;
  }

  /**
   * Get configuration errors for a module
   */
  getModuleErrors(allStatuses: ModuleConfigurationStatus[], moduleName: string): string[] {
    const moduleStatus = this.getModuleStatus(allStatuses, moduleName);
    return moduleStatus?.errors ?? [];
  }
}

export const configurationStatusApi = new ConfigurationStatusApi();
